import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Italic = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fill={color}
        d="M3 14L3.33832 12.6875H5.8125L8.73947 3.32589H6.26529L6.57345 2H13L12.6918 3.32589H10.2707L7.34375 12.6875H9.76488L9.42655 14H3Z"
      />
    </svg>
  )
})

export default Italic
